import { Component, Input } from '@angular/core';
import { MatListItem } from '@angular/material/list';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  selector: 'lc-area-menu-item',
  templateUrl: './area-menu-item.component.html',
  styleUrls: ['./area-menu-item.component.scss'],
  imports: [
    MatListItem,
    MatIcon,
    MatTooltip,
  ],
})
export class AreaMenuItemComponent {
  @Input() areaName: string;
  @Input() isExpanded: boolean = true;
}
